import { ThemeVariables } from '@/interfaces/theme';

import tokens from './tokens';
import palette from '../default/palette';

const variables = {
  bgElevated: palette.gray[0],
  bgComponentsContainer: palette.gray[2],

  hoverBackground: palette.alpha(palette.gray[12], 0.06),

  dividerColor: palette.gray[4],
  borderColor: palette.gray[4],

  shadowEffect: palette.gray[1],

  audioPlayerBackground: palette.alpha(palette.gray[12], 0.12),

  imageRatio: {
    background: palette.gray[3],
    iconColor: palette.gray[5]
  },

  tabs: {
    headerBackground: palette.gray[3],
    contentBackground: palette.gray[2]
  },

  resumeOfferButton: {
    background: palette.alpha(palette.gray[0], 0.04),
    color: palette.alpha(palette.gray[12], 0.65),
    border: palette.alpha(palette.gray[12], 0.65)
  },

  resumeSeeMoreButton: {
    background: palette.alpha(palette.gray[0], 0.04),
    color: tokens.colorPrimary,
    border: tokens.colorPrimary
  },

  courseModuleCheck: {
    background: palette.gray[12],
    color: palette.gray[0]
  },

  courseAuthorBorder: palette.alpha(palette.gray[12], 0.15),

  courseButtonWatchLesson: 'rgba(0, 0, 0, 0.04)',

  contentButtonWatchLesson: {
    background: palette.gray[12],
    color: palette.gray[0]
  },

  contentDownloadFileButton: {
    background: palette.alpha(palette.gray[12], 0.08)
  },

  contentCertificateButton: {
    background: palette.alpha(palette.gray[12], 0.08)
  },

  contentButtonSaveLesson: {
    border: palette.alpha(palette.gray[12], 0.5),
    background: palette.alpha(palette.gray[0], 0.5),
    color: palette.alpha(palette.gray[12], 0.5),

    hover: {
      background: palette.alpha(palette.gray[0], 0.85),
      color: palette.alpha(palette.gray[12], 0.85)
    }
  },

  myCoursesCardButtonText: palette.gray[0],

  notesPreview: {
    background: palette.gray[2],
    border: palette.alpha(palette.gray[12], 0.12)
  },

  integrationButton: {
    text: palette.gray[12],
    background: palette.gray[0],
    border: palette.gray[4]
  },

  pageBackgroundGradient: palette.alpha(palette.gray[0], 0.85),
  bgGradient: palette.gray[0],

  inputColor: palette.gray[2],
  inputColorBorder: palette.gray[4],
  loadingOverlayColor: palette.gray[2]
} as Partial<ThemeVariables>;

export default variables;
